<ng-container>
  <div *ngIf="isJustOneChild">
    <div *ngFor="let child of childrenList">
      <ng-container *ngComponentOutlet="child.component"></ng-container>
    </div>
  </div>

  <div *ngIf="!isJustOneChild">
    <mat-tab-group (selectedTabChange)="tabChange.emit($event)" [(selectedIndex)]="selectedTabIndex" [class]="tabGroupClass"
                   mat-stretch-tabs="{{ matTabStretch }}">
      <ng-container *ngFor="let child of children">
        <mat-tab [disabled]="child.disabled" [label]="child.labelEnum">
          <ng-template matTabLabel>{{ child.title }}</ng-template>
          <ng-template matTabContent>
            <ng-container *ngComponentOutlet="child.component"></ng-container>
          </ng-template>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>
</ng-container>
